import { useEffect, useRef } from 'react';

import { useAppDispatch } from '@/store/hooks';
import useSessionUuidParams from '@/utils/use-session-uuid-params';
import { fetchGreenroomMeeting } from '@/store/slices/project';

type TUseLoadMeetingData = {
  sessionUuid?: string;
};

const useLoadWorkingSessionMeetingData = (props?: TUseLoadMeetingData) => {
  const sessionUuidParams = useSessionUuidParams();
  const sessionUuid = props?.sessionUuid || sessionUuidParams;

  const dispatch = useAppDispatch();

  const fetching = useRef(false);

  useEffect(() => {
    if (!sessionUuid) return;
    if (fetching.current) return;

    fetching.current = true;
    dispatch(fetchGreenroomMeeting({ sessionUuid }));
  }, [dispatch, sessionUuid]);
};

export default useLoadWorkingSessionMeetingData;
